import { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { DELIVERY_TYPES, getOrderDeliveryType } from 'src/constants/deliveryTypes';
import { ORDER_DINE_IN_TYPE, ORDER_STATUS } from 'src/constants/order';
import { USER_PERMISSIONS } from 'src/constants/user';
import { localeStore } from 'src/mobx/localesStore';
import { animationSync } from 'src/utils/animationSync';
import { formatPriceSettings } from 'src/utils/formatter';
import { getCurrencySettings, getPaymentMethodIcon, getTranslate, hasPermissions } from 'src/utils/helpers';
import AggregatorManager, { getPaymentMethodIcon as getAggregatorPaymentMethodIcon } from 'src/view/components/AggregatorManager/AggregatorManager';
import Icon from 'src/view/components/Controls/Icon/Icon';
import { PAYMENT_TYPES } from '~/constants/main';
import { TOrder } from '~/types/orders';
import './style.scss';

interface IProps {
  order: TOrder;
  index: number;
  selected: boolean;
  onClick: (order: TOrder) => void;
  enableBlink?: boolean;
}

let animation: any;

export default class OrdersListItem extends Component<IProps> {
  enableSync = () => {
    if (animation) return null;
    else {
      animation = animationSync(['blink', 'blinkText', 'blinkSubtitle']);
    }
  };

  handleClick = () => {
    this.props.onClick(this.props.order);
  };

  componentDidMount = () => {
    this.enableSync();
  };

  getDeliveryIcon = (type: string | null): Icons => {
    if (type === DELIVERY_TYPES.DELIVERY) {
      return Icons.Delivery;
    } else if (this.props.order?.dinein?.dinein_delivery_type === ORDER_DINE_IN_TYPE.DINE_IN) {
      return Icons.DineIn;
    } else if (this.props.order?.curbside) {
      return Icons.Curbside;
    } else {
      return Icons.ShoppingBag;
    }
  };

  getNumber = (type: string | null) => {
    if (!this.props.order || type === null) return <Skeleton width={85} />;

    if (this.props.order?.dinein?.dinein_delivery_type === ORDER_DINE_IN_TYPE.DINE_IN) {
      return getTranslate(this.props.order.dinein.table?.name);
    } else {
      return this.props.order.customer_mobile;
    }
  };

  private get notViewed() {
    return !this.props.order.viewed;
  }

  private get styleClass() {
    let classList = '';
    if (this.props.selected) {
      classList += ' selected';
    }

    if (this.props.enableBlink && hasPermissions(USER_PERMISSIONS.ORDERS_MANAGMENT) && this.props.order?.order_status_code !== ORDER_STATUS.DRAFT) {
      if (this.notViewed) {
        classList += ' blink';
      }
      classList += ` orders-order-${this.props.order?.notification_type}`;
    }
    return classList;
    // return Boolean(this.props.order && !isNaN(this.props.order.viewed) && this.props.order.viewed === 0);
  }

  private getOrderPaymentMethodIcon(
    paymentType: PAYMENT_TYPES,
    aggregatorKey: number | null | undefined,
    dookTenantType: number | null | undefined
  ): any {
    if (!aggregatorKey) {
      return <Icon name={getPaymentMethodIcon(paymentType)} />;
    }
    return getAggregatorPaymentMethodIcon(aggregatorKey, dookTenantType);
  }

  render() {
    const { order, index } = this.props;
    const delivery_type = order ? getOrderDeliveryType(order.delivery_type_code) : null;
    return (
      <div id={`order-${order?.id || index}`} className={`orders-order ${this.styleClass}`} onClick={this.handleClick}>
        <div className="d-flex flex-row justify-content-between align-items-center mb-3">
          <p className="text-size-18 orders-order-subtitle family-medium">{order?.order_key || <Skeleton width={100} />}</p>

          <p className="orders-order-text orders-order-subtitle text-size-12 family-medium">
            {order ? localeStore.t(`${order.order_status_code}_status`) : <Skeleton width={50} />}
          </p>
        </div>

        <p className="orders-order-text text-uppercase text-elipsis mb-2">{order ? getTranslate(order.branch?.name) : <Skeleton width={85} />}</p>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <p className="orders-order-text text-uppercase">{order && order.customer_first_name ? order.customer_first_name : ''}</p>
          {order ? (
            this.getOrderPaymentMethodIcon(order.payment_type, order?.aggregator_key, order?.aggregator?.dook_tenant_type)
          ) : (
            <Skeleton width={14} />
          )}
        </div>

        <div className="d-flex flex-row justify-content-between align-items-center mt-2">
          <div className="orders-order-info">
            <p className="orders-order-text family-medium">{this.getNumber(delivery_type)}</p>
          </div>
          <AggregatorManager aggregator={order?.aggregator_key} sectionName="delivery">
            <p className="orders-order-text family-medium text-uppercase letter-spacing-12">
              {order ? <Icon name={this.getDeliveryIcon(delivery_type)} size={14} /> : <Skeleton width={60} />}
            </p>
          </AggregatorManager>
          <div className="orders-order-info d-flex justify-content-end">
            <p className="orders-order-text family-medium">
              {order ? formatPriceSettings(order.total, getCurrencySettings(order)) : <Skeleton width={50} />}
            </p>
          </div>
        </div>
      </div>
    );
  }
}
